import {onDomReady} from "../lib/on_dom_ready";

onDomReady(() => {
  const limitOrganizationAdmins = document.querySelector("#organization_settings_limit_organization_admins_value");
  const organizationAdminsLimit = document.querySelector("#organization_admins_limit");

  if (!limitOrganizationAdmins || !organizationAdminsLimit) {
    return;
  }

  function updateOrganizationAdminsLimit() {
    if (limitOrganizationAdmins.checked) {
      organizationAdminsLimit.classList.remove("hidden");
    } else {
      organizationAdminsLimit.classList.add("hidden");
    }
  }

  updateOrganizationAdminsLimit();
  limitOrganizationAdmins.addEventListener("change", updateOrganizationAdminsLimit);
});
